import React, { useCallback, useState } from 'react';
import closeIcon from 'assets/icons/close.svg';
import './CopyLogic.pcss';
import useRouter from 'use-react-router';
import { useSelector, shallowEqual } from 'react-redux';
import {
  generatePageStructure,
  nameById,
} from '@mm/state/helpers/filterable-select-helpers';
import FilterableSelect from '../../../../../../common/components/FilterableSelect/FilterableSelect';
import Button from '../../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import WidgetModel, {
  WidgetConditionalAudience,
  WidgetConditionalFilter,
  WidgetConditionalTag,
} from '@mm/state/model/WidgetModel';
import { StoreState } from '@mm/state/store-interfaces';
import {
  PrimaryButton,
  ButtonColor,
} from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { ESCAPE_KEY_NAME } from '@mm/constants/keys-codes';
import { useKeyDown } from '../../../../../../common/hooks/use-key-down';

type OuterProps = {
  onClose: () => void;
  onCopyWidget: (dialogId: number) => void;
  initialDialogueId?: number;
};

export type WidgetModelConditionalLogic = Pick<
  WidgetModel,
  'conditionalAudiences' | 'conditionalFilters' | 'conditionalTags'
>;
export type ConditionalLogicModeProps = OuterProps & {
  editWidget: WidgetModelConditionalLogic;
  setEditWidget: (widget: WidgetModelConditionalLogic) => void;
  changesPending: boolean;
  editFilter?: WidgetConditionalFilter;
  setEditFilter: (filter?: WidgetConditionalFilter) => void;
  conditionalTags: WidgetConditionalTag[];
  conditionalFilters: WidgetConditionalFilter[];
  conditionalAudiences: WidgetConditionalAudience[];
  loadingAudienceVariables: boolean;
};

type Props = OuterProps;
export const CopyLogic = (props: Props) => {
  const { onClose, onCopyWidget, initialDialogueId } = props;

  const { match } = useRouter<{ chatbotId: string; pageId: string }>();
  const [dialogId, setDialogId] = useState(
    initialDialogueId || Number(match.params.pageId),
  );

  const { pages, pageGroups } = useSelector(
    (state: StoreState) => ({
      pages: state.page.entities,
      pageGroups: state.pageGroup.entities,
    }),
    shallowEqual,
  );

  const onSelectDialog = useCallback(id => setDialogId(id), [setDialogId]);
  const handleCopyWidget = useCallback(() => {
    onCopyWidget(dialogId);
    onClose();
  }, [onCopyWidget, dialogId, onClose]);

  const onKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'ESCAPE_KEY_NAME') {
        onClose();
      }
    },
    [onClose],
  );

  useKeyDown(onKeyDown);

  return (
    <div className="widget-conditional-logic disable-sortable-hoc">
      <div className="widget-conditional-logic__header-text">
        Copy widget to Dialogue
      </div>
      <Button
        text
        className="widget-conditional-logic__close-button"
        onClick={onClose}
      >
        <img alt="Close" src={closeIcon} />
      </Button>
      <FilterableSelect
        outerValue={nameById(dialogId, pages)}
        onChange={onSelectDialog}
        suggestions={generatePageStructure(pages, pageGroups)}
        className="widget-copy-logic__select"
      />
      <div className="widget-copy-logic__action_row">
        <PrimaryButton
          className="widget-copy-logic__cancel-button"
          color={ButtonColor.secondaryBlue}
          onClick={onClose}
        >
          Cancel
        </PrimaryButton>
        <PrimaryButton color={ButtonColor.blue} onClick={handleCopyWidget}>
          Ok
        </PrimaryButton>
      </div>
    </div>
  );
};
